export const varTeal400 = '#75CDC0';
export const varRaspberry400 = '#DC5899';
export const varCoolgray200 = '#E4E5E9';
export const varStatusSuccess200 = '#58BF81';
export const varNeutralBlack = '#000000';
export const varNeutral200 = '#E4E5E9';
export const varIndigo400 = '#e6f2fc';
export const varIndigo500 = '#518AD7';
export const varIndigo800 = '#1C355E';

export const varRSVPDataColor1 = '#FBBB03';
export const varRSVPDataColor2 = '#FF44CB';
export const varRSVPDataColor3 = '#A1CDF5';
export const varRSVPDataColor4 = '#FF9357';
export const varRSVPDataColor5 = '#FEBBF7';
